import { DirectUploadMedia } from "libs/directUpload";
import * as yup from "yup";

const noConsecutiveSpaces = /^(?!.*\s{2,})(?!^\s)/;

const stringValidation = (value: string) => {
  return yup
    .string()
    .required(`${value} is required field`)
    .min(3, `The ${value} field should contain at least 3 letters.`)
    .matches(
      noConsecutiveSpaces,
      `The ${value} field cannot contain consecutive spaces or start with a space.`
    );
};

export const expenseSchema = yup.object({
  title: stringValidation("Title"),
  amount: yup
    .number()
    .transform((value, original) => (original === "" ? null : value))
    .nullable()
    .defined()
    .min(1, "Amount can not be less than 1")
    .test(
      "is-present",
      "Amount is required field",
      (value) => value !== null && value !== undefined
    ),
  type: stringValidation("Type"),
  quantity: yup
    .number()
    .transform((value, original) => (original === "" ? null : value))
    .nullable()
    .defined()
    .min(1, "Quantity can not be less than 1")
    .test(
      "is-present",
      "Quantity is required field",
      (value) => value !== null && value !== undefined
    ),
  description: stringValidation("Description"),
  paymentMethod: stringValidation("Payment method"),
  responsiblePersonName: stringValidation("Person Name"),
  paymentProofs: yup
    .array()
    .of(yup.mixed<DirectUploadMedia>().defined())
    .required(),
  expenseProofs: yup
    .array()
    .of(yup.mixed<DirectUploadMedia>().defined())
    .required()
});
